<p>new-quickloan-cibil-report works!</p>
<button (click)="getCRCThirdDetail()">Click</button>
<!-- new-quickloan-cibil-report.component.html -->
<div
  class="modal fade in"
  id="cibilReport"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6
          class="modal-title"
          id="myModalLabel"
          name="myModalLabel"
          style="margin: 0"
        >
          Cibil Report
        </h6>
        <button
          type="button"
          (click)="onCloseCibilReport()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>

      <div class="modal-body" style="font-size: 0.625rem">
        <ng-container>
          <div class="row m-0">
            <div class="text-right mt-2 mb-2">
              <button
                type="button"
                class="btn font-size-12 button-btn ml-2"
                (click)="onDocsPrint('TransUnionCIBIL')"
              >
                Print
              </button>
            </div>
          </div>

          <div
            id="TransUnionCIBIL"
            style="
              font-family: Arial, sans-serif;
              color: #333;
              line-height: 1.6;
              margin-bottom: 1.25rem;
              background: white;
              box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.1);
              border-radius: 0.5rem;
              padding: 1.5625rem;
            "
          >
            <!-- Report Header -->
            <div style="margin-bottom: 1.5625rem">
              <!-- Report Header -->
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding-bottom: 0.9375rem;
                  border-bottom: 2px solid #00a6ca;
                  margin-bottom: 1.5625rem;
                "
              >
                <div
                  style="
                    display: flex;
                    gap: 0.9375rem;
                    align-items: center;
                    flex-wrap: wrap;
                  "
                >
                  <div>
                    <span style="font-weight: bold; color: #00c3ff"
                      >REPORT DATE & TIME:</span
                    >
                    {{ currentDate | date : "dd/MM/yyyy (HH:mm:ss)" }}
                  </div>
                  <span>|</span>
                  <div>
                    <span style="font-weight: bold; color: #00c3ff"
                      >CONTROL NUMBER:</span
                    >
                    2159680964
                  </div>
                </div>
                <img
                  src="assets/transunion.png"
                  alt="TransUnionCIBIL"
                  style="height: 3.125rem"
                />
              </div>

              <!-- Consumer CIR Section -->
              <h2
                style="
                  font-size: 1.375rem;
                  font-weight: 700;
                  margin: 0px;
                  padding-bottom: 0.75rem;
                "
              >
                CONSUMER CIR
              </h2>

              <div
                style="
                  margin-bottom: 1.875rem;
                  border-radius: 0.375rem;
                  page-break-inside: avoid;
                  padding: 0.3125rem 0.3125rem;
                  border: 1px solid #e0e0e0;
                "
              >
                <div
                  style="
                    padding: 0.3125rem 0px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div>
                    <span style="color: #00a6ca">MEMBER ID:</span> BFxxxxxxxx
                  </div>
                  <div>
                    <span style="color: #00a6ca">REFERENCE NUMBER:</span> 1234
                  </div>
                </div>
              </div>

              <!-- Consumer Information -->
              <h3
                style="
                  font-size: 1.125rem;
                  font-weight: 600;
                  padding-bottom: 0px;
                  margin: 1.125rem 0.3125rem 0px !important;
                "
              >
                CONSUMER INFORMATION
              </h3>
              <div
                style="
                  margin-bottom: 1.875rem;
                  border-radius: 0.375rem;
                  page-break-inside: avoid;
                  padding: 0.3125rem 0.3125rem;
                  border: 1px solid #e0e0e0;
                "
              >
                <div style="padding: 0.3125rem 0px">
                  <div style="display: flex; flex-wrap: wrap">
                    <div style="flex: 1; min-width: 18.75rem">
                      <div>
                        <strong style="color: #00a6ca">CONSUMER NAME:</strong>
                        {{ cibilData?.consumerCreditData[0]?.names[0]?.name }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">PAN:</strong>
                        {{ getIdNumber("01") }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">DOB:</strong>
                        {{
                          formatDate(
                            cibilData?.consumerCreditData[0]?.names[0]
                              ?.birthDate
                          )
                        }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca"
                          >DRIVING LICENCE NO:</strong
                        >
                        {{ getIdNumber("04") }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">TELEPHONE NO.:</strong>
                        {{
                          cibilData?.consumerCreditData[0]?.telephones[0]
                            ?.telephoneNumber
                        }}
                      </div>
                    </div>
                    <div style="flex: 1; min-width: 18.75rem">
                      <div>
                        <strong style="color: #00a6ca">VOTER ID:</strong>
                        {{ getIdNumber("03") }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">EMAIL ID:</strong>
                        {{
                          cibilData?.consumerCreditData[0]?.emails[0]?.emailID
                        }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">PASSPORT NO:</strong>
                        {{ getIdNumber("02") }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">GENDER:</strong>
                        {{
                          getGenderText(
                            cibilData?.consumerCreditData[0]?.names[0]?.gender
                          )
                        }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">AADHAAR NUMBER:</strong>
                        {{ getIdNumber("06") }}
                      </div>
                    </div>
                  </div>
                  <div style="margin-top: 0.9375rem">
                    <strong style="color: #00a6ca">ADDRESS:</strong>
                    {{
                      formatAddress(
                        cibilData?.consumerCreditData[0]?.addresses[0]
                      )
                    }}
                  </div>
                </div>
              </div>

              <!-- CIBIL Scores -->
              <h3
                style="
                  font-size: 1.125rem;
                  font-weight: 600;
                  padding-bottom: 0px;
                  margin: 1.125rem 0.3125rem 0px !important;
                "
              >
                CIBIL TRANSUNION SCORE(S)
              </h3>

              <div style="padding: 0.3125rem 0px">
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 1.25rem;
                    justify-content: center;
                  "
                >
                  <!-- CreditVision Score Card -->
                  <div
                    style="
                      flex: 0 0 calc(50% - 0.625rem);
                      min-width: 20rem;
                      max-width: 31.25rem;
                    "
                  >
                    <div
                      style="
                        text-align: center;
                        padding: 1.25rem;
                        border: 1px solid #e0e0e0;
                        border-radius: 0.5rem;
                        background: #f9f9f9;
                        height: 100%;
                        min-height: 31.25rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        box-sizing: border-box;
                      "
                    >
                      <div>
                        <h4
                          style="
                            color: #2c3e50;
                            font-size: 1rem;
                            font-weight: 600;
                            margin-bottom: 0.9375rem;
                          "
                        >
                          CREDITVISION® Score
                        </h4>

                        <div
                          style="
                            width: 12.5rem;
                            height: 12.5rem;
                            margin: 0 auto 0.9375rem;
                            position: relative;
                          "
                        >
                          <canvas #creditVisionChartRef></canvas>
                        </div>

                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            font-size: 0.875rem;
                            color: #7f8c8d;
                            margin-bottom: 0.625rem;
                          "
                        >
                          <span>300 (high risk)</span>
                          <span>900 (low risk)</span>
                        </div>
                        <div
                          style="
                            font-size: 1.125rem;
                            font-weight: 600;
                            color: #27ae60;
                            padding: 0.3125rem;
                            border-radius: 0.25rem;
                            background: rgba(39, 174, 96, 0.1);
                            margin-top: 0.625rem;
                          "
                        >
                          Good
                        </div>
                      </div>

                      <!-- Scoring Factors for CreditVision -->
                      <div style="margin-top: 1.25rem; text-align: left">
                        <div
                          style="
                            font-weight: 600;
                            color: #00a6ca;
                            margin-bottom: 0.625rem;
                            padding-bottom: 0.3125rem;
                            border-bottom: 1px dashed #e0e0e0;
                          "
                        >
                          SCORING FACTORS
                        </div>
                        <ol style="padding-left: 1.25rem; margin-bottom: 0">
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Presence Of Delinquency
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Low Proportion Of Satisfactory Trades
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Low Credit Age
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            High Balance Build-Up On Non-Mortgage Loans
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Presence Of Delinquency In The Recent Past
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>

                  <!-- Personal Loan Score Card -->
                  <div
                    style="
                      flex: 0 0 calc(50% - 0.625rem);
                      min-width: 20rem;
                      max-width: 31.25rem;
                    "
                  >
                    <div
                      style="
                        text-align: center;
                        padding: 1.25rem;
                        border: 1px solid #e0e0e0;
                        border-radius: 0.5rem;
                        background: #f9f9f9;
                        height: 100%;
                        min-height: 31.25rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        box-sizing: border-box;
                      "
                    >
                      <div>
                        <h4
                          style="
                            color: #2c3e50;
                            font-size: 1rem;
                            font-weight: 600;
                            margin-bottom: 0.9375rem;
                          "
                        >
                          PERSONAL LOAN Score
                        </h4>
                        <div
                          style="
                            width: 12.5rem;
                            height: 12.5rem;
                            margin: 0 auto 0.9375rem;
                            position: relative;
                          "
                        >
                          <canvas #personalLoanChartRef></canvas>
                        </div>

                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            font-size: 0.875rem;
                            color: #7f8c8d;
                            margin-bottom: 0.625rem;
                          "
                        >
                          <span>300 (high risk)</span>
                          <span>900 (low risk)</span>
                        </div>
                        <div
                          style="
                            font-size: 1.125rem;
                            font-weight: 600;
                            color: #27ae60;
                            padding: 0.3125rem;
                            border-radius: 0.25rem;
                            background: rgba(39, 174, 96, 0.1);
                            margin-top: 0.625rem;
                          "
                        >
                          {{ getScoreRating(calculatePersonalLoanScore()) }}
                        </div>
                      </div>

                      <!-- Scoring Factors for Personal Loan -->
                      <div style="margin-top: 1.25rem; text-align: left">
                        <div
                          style="
                            font-weight: 600;
                            color: #00a6ca;
                            margin-bottom: 0.625rem;
                            padding-bottom: 0.3125rem;
                            border-bottom: 1px dashed #e0e0e0;
                          "
                        >
                          SCORING FACTORS
                        </div>
                        <ol style="padding-left: 1.25rem; margin-bottom: 0">
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Credit card balances are high in proportion to High
                            Credit Amount
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Low proportion of satisfactory trades
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Low average trade age
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Total balance of delinquencies is too high
                          </li>
                          <li style="margin-bottom: 0.5rem; color: #34495e">
                            Not enough available credit
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              CONSUMER SUMMARY
            </h3>
            <div
              style="
                margin-bottom: 1.875rem;
                border-radius: 0.375rem;
                page-break-inside: avoid;
                padding: 0.3125rem 0.3125rem;
                border: 1px solid #e0e0e0;
              "
            >
              <div style="padding: 0.3125rem 0px">
                <div style="display: flex; flex-wrap: wrap">
                  <div style="flex: 1; min-width: 12.5rem; padding: 0 0.625rem">
                    <h4
                      style="
                        color: #00a6ca;
                        font-size: 1rem;
                        font-weight: 600;
                        margin-bottom: 0.9375rem;
                      "
                    >
                      ACCOUNTS
                    </h4>
                    <div>
                      <strong style="color: #00a6ca">Total:</strong>
                      {{
                        cibilData?.consumerSummaryData?.accountSummary
                          ?.totalAccounts || 0
                      }}
                    </div>
                    <div>
                      <strong style="color: #00a6ca">Zero balance:</strong>
                      {{
                        cibilData?.consumerSummaryData?.accountSummary
                          ?.zeroBalanceAccounts || 0
                      }}
                    </div>
                    <div>
                      <strong style="color: #00a6ca">Overdue:</strong>
                      {{
                        cibilData?.consumerSummaryData?.accountSummary
                          ?.overdueAccounts || 0
                      }}
                    </div>
                  </div>
                  <div style="flex: 1; min-width: 12.5rem; padding: 0 0.625rem">
                    <h4
                      style="
                        color: #00a6ca;
                        font-size: 1rem;
                        font-weight: 600;
                        margin-bottom: 0.9375rem;
                      "
                    >
                      BALANCES
                    </h4>
                    <div>
                      <strong style="color: #00a6ca">High Cr/Sanc. Amt:</strong>
                      {{
                        formatCurrency(
                          cibilData?.consumerSummaryData?.accountSummary
                            ?.highCreditAmount
                        )
                      }}
                    </div>
                    <div>
                      <strong style="color: #00a6ca">Current:</strong>
                      {{
                        formatCurrency(
                          cibilData?.consumerSummaryData?.accountSummary
                            ?.currentBalance
                        )
                      }}
                    </div>
                    <div>
                      <strong style="color: #00a6ca">Overdue:</strong>
                      {{
                        formatCurrency(
                          cibilData?.consumerSummaryData?.accountSummary
                            ?.overdueBalance
                        )
                      }}
                    </div>
                  </div>
                  <div style="flex: 1; min-width: 12.5rem; padding: 0 0.625rem">
                    <h4
                      style="
                        color: #00a6ca;
                        font-size: 1rem;
                        font-weight: 600;
                        margin-bottom: 0.9375rem;
                      "
                    >
                      ACCOUNT OPENED DATE
                    </h4>
                    <div>
                      <strong style="color: #00a6ca">Recent:</strong>
                      {{
                        formatDate(
                          cibilData?.consumerSummaryData?.accountSummary
                            ?.recentDateOpened
                        )
                      }}
                    </div>
                    <div>
                      <strong style="color: #00a6ca">Oldest:</strong>
                      {{
                        formatDate(
                          cibilData?.consumerSummaryData?.accountSummary
                            ?.oldestDateOpened
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Enquiry Summary -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              ENQUIRY SUMMARY
            </h3>
            <div style="padding: 0.3125rem 0px">
              <table
                style="
                  width: 100%;
                  margin-bottom: 0.625rem;
                  font-size: 0.75rem;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      TOTAL ENQUIRIES
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      MOST RECENT
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      PAST 30 DAYS
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      PAST 12 MONTHS
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      PAST 24 MONTHS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        cibilData?.consumerSummaryData?.inquirySummary
                          ?.totalInquiry || 0
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        formatDate(
                          cibilData?.consumerSummaryData?.inquirySummary
                            ?.recentInquiryDate
                        )
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        cibilData?.consumerSummaryData?.inquirySummary
                          ?.inquiryPast30Days || 0
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        cibilData?.consumerSummaryData?.inquirySummary
                          ?.inquiryPast12Months || 0
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        cibilData?.consumerSummaryData?.inquirySummary
                          ?.inquiryPast24Months || 0
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- CreditVision Algorithms -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              CREDITVISION® ALGORITHM(S)
            </h3>
            <div style="padding: 0.3125rem 0px">
              <table
                style="
                  width: 100%;
                  margin-bottom: 0.625rem;
                  font-size: 0.75rem;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      COHORT
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      DESCRIPTION (NAME)
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      VALUE
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      RISK SCALE
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- PAYMENT BEHAVIOUR Section -->
                  <tr>
                    <td
                      rowspan="7"
                      style="
                        background-color: #e9ecef;
                        font-weight: bold;
                        text-align: center;
                        vertical-align: middle;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        "
                      >
                        <img
                          src="assets/paymentBehaviour.png"
                          alt="Payment Behaviour"
                          style="width: 2.5rem; height: 2.5rem"
                        />
                        PAYMENT BEHAVIOUR
                      </div>
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Percentage of payments missed in the last 12 months
                      (PAYMNT63)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{ getBureauCharacteristicValue("PAYMNT63") }}%
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 66.67%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">0%</span>
                            <span style="font-weight: 600">15%</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Maximum delinquency across all trades (GSI1S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      90+ DPD
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 100%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">0</span>
                            <span style="font-weight: 600">90+</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Months since most recent delinquency (30+ DPD) (AT36S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      0 M
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 0%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                              flex-direction: row-reverse;
                            "
                          >
                            <span style="font-weight: 600">12+</span>
                            <span style="font-weight: 600">0</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Percentage of non delinquent open trades to all open
                      trades (AT103S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      20%
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 80%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                              flex-direction: row-reverse;
                            "
                          >
                            <span style="font-weight: 600">100%</span>
                            <span style="font-weight: 600">0%</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Number of accounts prior 60 days past due, now current (0
                      DPD) (CV18)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      2
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 40%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">5+</span>
                            <span style="font-weight: 600">0</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Aggregate excess 40K+ amount paid for all accounts over
                      the past 6 months (ALL233)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      ₹ 0
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 0%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">40K+</span>
                            <span style="font-weight: 600">0</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Customer category basis credit card payment behaviour
                      (BCPMTSTR)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      NOBC
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      No open bankcards
                    </td>
                  </tr>

                  <!-- LEVERAGE Section -->
                  <tr>
                    <td
                      rowspan="2"
                      style="
                        background-color: #e9ecef;
                        font-weight: bold;
                        text-align: center;
                        vertical-align: middle;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        "
                      >
                        <img
                          src="assets/leverage.png"
                          alt="Leverage"
                          style="width: 2.5rem; height: 2.5rem"
                        />
                        LEVERAGE
                      </div>
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Index to measure balance movement across all trades
                      (excluding home and property loans) in last 24 months
                      (BALMAG01)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      500
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                position: absolute;
                                top: -2px;
                                left: 50%;
                                width: 0.1875rem;
                                height: 1rem;
                                background-color: #2c3e50;
                                transform: translateX(-50%);
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">Pay Down</span>
                            <span style="font-weight: 600">Debt Build Up</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Utilization for open trades (AT34A)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      80%
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 80%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">0%</span>
                            <span style="font-weight: 600">100%</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- RECENCY Section -->
                  <tr>
                    <td
                      rowspan="2"
                      style="
                        background-color: #e9ecef;
                        font-weight: bold;
                        text-align: center;
                        vertical-align: middle;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        "
                      >
                        <img
                          src="assets/recency.png"
                          alt="Recency"
                          style="width: 2.5rem; height: 2.5rem"
                        />
                        RECENCY
                      </div>
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Number of trades opened in past 6 months (AT06S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      4
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      -
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Number of enquiries in past 3 months (G503S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      7
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      -
                    </td>
                  </tr>

                  <!-- DEMOGRAPHIC STABILITY INDEX Section -->
                  <tr>
                    <td
                      rowspan="3"
                      style="
                        background-color: #e9ecef;
                        font-weight: bold;
                        text-align: center;
                        vertical-align: middle;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        "
                      >
                        <img
                          src="assets/group.png"
                          alt="Demographic Stability"
                          style="width: 2.5rem; height: 2.5rem"
                        />
                        DEMOGRAPHIC STABILITY INDEX
                      </div>
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Number of distinct phones reported in the last 3 months
                      (DM207S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      1
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 20%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">0</span>
                            <span style="font-weight: 600">5+</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Number of distinct addresses reported in the last 3 months
                      (DM217S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      2
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 40%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">0</span>
                            <span style="font-weight: 600">5+</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Number of distinct IDs reported in the last 3 months
                      (DM247S)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      3
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <div style="padding: 0.3125rem 0">
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            gap: 0.1875rem;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              height: 0.75rem;
                              background-color: #ecf0f1;
                              border-radius: 0.25rem;
                              overflow: hidden;
                            "
                          >
                            <div
                              style="
                                height: 100%;
                                background-color: #00a6ca;
                                border-radius: 0.25rem;
                                width: 60%;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 0.625rem;
                              color: #7f8c8d;
                            "
                          >
                            <span style="font-weight: 600">0</span>
                            <span style="font-weight: 600">5+</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h2
              style="
                font-size: 1.375rem;
                font-weight: 700;
                margin: 0px;
                padding-bottom: 0.75rem;
              "
            >
              CONSUMER DETAILS
            </h2>
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              CONSUMER INFORMATION
            </h3>
            <div style="padding: 0.3125rem 0px">
              <div>
                <table
                  style="
                    width: 100%;
                    margin-bottom: 0.625rem;
                    font-size: 0.75rem;
                    border-collapse: collapse;
                  "
                >
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <strong style="color: #00a6ca">CONSUMER NAME:</strong>
                      {{ cibilData?.consumerCreditData[0]?.names[0]?.name }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <strong style="color: #00a6ca">D.O.B:</strong>
                      {{
                        formatDate(
                          cibilData?.consumerCreditData[0]?.names[0]?.birthDate
                        )
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <strong style="color: #00a6ca">GENDER:</strong>
                      {{
                        getGenderText(
                          cibilData?.consumerCreditData[0]?.names[0]?.gender
                        )
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <strong style="color: #00a6ca"
                        >CREDITVISION® SCORE:</strong
                      >
                      {{ cibilData?.consumerCreditData[0]?.scores[0]?.score }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="4"
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <h4
                        style="
                          color: #00a6ca;
                          font-size: 1rem;
                          font-weight: 600;
                          margin: 0.625rem 0;
                        "
                      >
                        INFORMATION UNDER DISPUTE
                      </h4>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="2"
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <strong style="color: #00a6ca">CIBIL REMARKS:</strong>
                      DATE OF BIRTH IN DISPUTE
                    </td>
                    <td
                      colspan="2"
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      <strong style="color: #00a6ca">DATE ENTERED:</strong>
                      10/11/2022
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Identifications -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              IDENTIFICATION(S)
            </h3>
            <div style="padding: 0.3125rem 0px">
              <table
                style="
                  width: 100%;
                  margin-bottom: 0.625rem;
                  font-size: 0.75rem;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      IDENTIFICATION TYPE
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      IDENTIFICATION NUMBER
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      ISSUE DATE
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      EXPIRATION DATE
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ids of cibilData?.consumerCreditData[0]?.ids">
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      {{
                        ids?.idType != undefined
                          ? ids?.idType == "01"
                            ? "Income Tax ID Number (PAN)"
                            : ids?.idType == "02"
                            ? "Passport Number"
                            : ids?.idType == "03"
                            ? "Voter ID Number"
                            : ids?.idType == "04"
                            ? "Driver's License Number"
                            : ids?.idType == "05"
                            ? "Ration Card Number"
                            : ids?.idType == "06"
                            ? "Universal ID Number (UID) / Aadhaar Number"
                            : ids?.idType == "07"
                            ? "Additional ID 1 (For Future Use)"
                            : ids?.idType == "08"
                            ? "Additional ID 2 (For Future Use)"
                            : ids?.idType == "09"
                            ? "CKYC"
                            : ids?.idType == "10"
                            ? "NREGA Card Number"
                            : ""
                          : ""
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{ ids?.idNumber != undefined ? ids?.idNumber : "" }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        ids?.idType != undefined
                          ? formatDate(ids?.issueDate)
                          : ""
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        ids?.idType != undefined ? formatDate(ids?.idType) : ""
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style="color: #6c757d; font-size: 0.6875rem; margin-top: 0.3125rem">
                (e) - IDENTIFICATION REPORTED FROM ENQUIRY
              </div>
            </div>

            <!-- Telephones -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              TELEPHONE(S)
            </h3>
            <div style="padding: 0.3125rem 0px">
              <table
                style="
                  width: 100%;
                  margin-bottom: 0.625rem;
                  font-size: 0.75rem;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      TYPE
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      TELEPHONE NUMBER
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      TELEPHONE EXTENSION
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let telephoneNo of cibilData?.consumerCreditData[0]
                        ?.telephones
                    "
                  >
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      {{
                        telephoneNo?.telephoneType == "01"
                          ? "Mobile Phone"
                          : telephoneNo?.telephoneType == "02"
                          ? "Home Phone"
                          : telephoneNo?.telephoneType == "03"
                          ? "Office Phone"
                          : "Not Classified" || " "
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{ telephoneNo?.telephoneNumber || "" }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{ telephoneNo?.enquiryEnriched || "" }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style="color: #6c757d; font-size: 0.6875rem; margin-top: 0.3125rem">
                (e) - TELEPHONE REPORTED FROM ENQUIRY
              </div>
            </div>

            <!-- Email Contacts -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              EMAIL CONTACT(S)
            </h3>
            <div
              style="
                margin-bottom: 1.875rem;
                border-radius: 0.375rem;
                page-break-inside: avoid;
                padding: 0.3125rem 0.3125rem;
                border: 1px solid #e0e0e0;
              "
            >
              <div style="padding: 0.3125rem 0px">
                <div style="display: flex; flex-wrap: wrap; gap: 0.625rem">
                  <div
                    *ngFor="
                      let email of cibilData?.consumerCreditData[0]?.emails
                    "
                    style="
                      padding: 0.3125rem 0.625rem;
                      background: #f8f9fa;
                      border-radius: 0.25rem;
                    "
                  >
                    {{ email.emailID }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Addresses -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              CONSUMER'S REPORTED ADDRESS(ES)
            </h3>
            <div style="padding: 0.3125rem 0px">
              <table
                style="
                  width: 100%;
                  margin-bottom: 0.625rem;
                  font-size: 0.75rem;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      ADDRESS
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      CATEGORY
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      RESIDENCE CODE
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      DATE REPORTED
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let address of cibilData?.consumerCreditData[0]?.addresses
                    "
                  >
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      {{ address.line1 }},{{ address.line5 }},{{
                        address.stateCode
                      }},{{ address.pinCode }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      {{
                        address.addressCategory == "01"
                          ? "Permanent Address"
                          : address.addressCategory == "02"
                          ? "Residence Address"
                          : address.addressCategory == "03"
                          ? "Office Address"
                          : address.addressCategory == "05"
                          ? "Mortgage Property address"
                          : "Not Categorized"
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      -
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{ formatDate(address.dateReported) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style="color: #6c757d; font-size: 0.6875rem; margin-top: 0.3125rem">
                (e) - ADDRESSES REPORTED FROM ENQUIRY
              </div>
            </div>

            <!-- Employment Information -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              EMPLOYMENT INFORMATION
            </h3>
            <div style="padding: 0.3125rem 0px">
              <table
                style="
                  width: 100%;
                  margin-bottom: 0.625rem;
                  font-size: 0.75rem;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      ACCOUNT TYPE (Date Reported)
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      OCCUPATION CODE
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      INCOME
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      NET/GROSS INCOME INDICATOR
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      MONTHLY/ANNUAL INCOME INDICATOR
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let empInfo of cibilData?.consumerCreditData[0]
                        ?.employment
                    "
                  >
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      {{
                        findItemById(empInfo?.accountType) == null
                          ? ""
                          : findItemById(empInfo?.accountType)
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        empInfo?.occupationCode == "01"
                          ? "Salaried"
                          : empInfo?.occupationCode == "02"
                          ? "Self Employed Professional"
                          : empInfo?.occupationCode == "03"
                          ? "Self Employed"
                          : empInfo?.occupationCode == "04"
                          ? "Others"
                          : ""
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        empInfo?.incomeType === "N"
                          ? "Net Income"
                          : "Gross Income"
                      }}
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        empInfo?.incomeFrequency === "M" ? "Monthly" : "Annual"
                      }}
                    </td>
                    <!-- <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      {{
                        empInfo?.incomeFrequency === "M" ? "Monthly" : "Annual"
                      }}
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Account Details -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              CONSUMER ACCOUNT DETAILS
            </h3>
            <div *ngIf="cibilData?.consumerCreditData[0]?.accounts?.length">
              <div
                *ngFor="
                  let account of cibilData.consumerCreditData[0].accounts;
                  let i = index
                "
                style="
                  border: 1px solid #ccc;
                  margin-bottom: 1.25rem;
                  border-radius: 0.25rem;
                  padding: 0.625rem;
                  background: #fff;
                "
              >
                <h4 style="color: #000; font-weight: bold; margin-bottom: 0.625rem">
                  {{ i + 1 }}. ACCOUNT
                </h4>

                <!-- Account Info Header -->
                <div style="margin-bottom: 0.625rem">
                  <table
                    style="
                      width: 100%;
                      margin-bottom: 0.625rem;
                      font-size: 0.75rem;
                      border-collapse: collapse;
                    "
                  >
                    <tr>
                      <td
                        style="
                          font-weight: bold;
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        ACCOUNT INFORMATION
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        <strong style="color: #00a6ca">DATE OPENED:</strong>
                        {{ formatDate(account.dateOpened) }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        <strong style="color: #00a6ca">DATE CLOSED:</strong>
                        {{ formatDate(account.dateClosed) }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        <strong style="color: #00a6ca"
                          >DATE REPORTED & CERTIFIED:</strong
                        >
                        {{ formatDate(account.dateReported) }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                          text-align: right;
                        "
                      >
                        <span
                          [style]="
                            account.currentBalance === 0
                              ? 'padding: 0.1875rem 0.625rem; border-radius: 0.1875rem; font-weight: bold; font-size: 0.9rem; color: #fff; background: #6c757d;'
                              : 'padding: 0.1875rem 0.625rem; border-radius: 0.1875rem; font-weight: bold; font-size: 0.9rem; color: #fff; background: #28a745;'
                          "
                        >
                          {{
                            account.currentBalance === 0 ? "INACTIVE" : "ACTIVE"
                          }}
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>

                <!-- Account + Amounts + Status -->
                <table
                  style="
                    width: 100%;
                    margin-bottom: 0.625rem;
                    font-size: 0.75rem;
                    border-collapse: collapse;
                  "
                >
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      ACCOUNT
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      AMOUNTS
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      STATUS
                    </th>
                  </tr>
                  <tr>
                    <!-- ACCOUNT -->
                    <td
                      style="
                        vertical-align: top;
                        padding: 0.375rem 0.5rem;
                        border: 1px solid #dee2e6;
                        line-height: 1.6;
                      "
                    >
                      <div>
                        <strong style="color: #00a6ca">TYPE</strong> :
                        {{ getAccountTypeText(account.accountType) }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">MEMBER NAME</strong> :
                        {{ account.memberShortName || "NOT DISCLOSED" }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">ACCOUNT NUMBER</strong> :
                        {{ account.index }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">OWNERSHIP</strong> :
                        {{
                          account.ownershipIndicator == 1
                            ? "Individual"
                            : account.ownershipIndicator == 2
                            ? "Authorised User (refers to supplementary credit card holder)"
                            : account.ownershipIndicator == 3
                            ? "Guarantor"
                            : account.ownershipIndicator == 4
                            ? "Joint"
                            : account.ownershipIndicator == 5
                            ? "Deceased"
                            : ""
                        }}
                      </div>
                    </td>

                    <!-- AMOUNTS -->
                    <td
                      style="
                        vertical-align: top;
                        padding: 0.375rem 0.5rem;
                        border: 1px solid #dee2e6;
                        line-height: 1.6;
                      "
                    >
                      <div>
                        <strong style="color: #00a6ca"
                          >SANCTIONED AMOUNT</strong
                        >
                        :
                        {{ formatCurrency(account.highCreditAmount) }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">CURRENT BALANCE</strong>
                        :
                        {{ formatCurrency(account.currentBalance) }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">OVERDUE</strong> :
                        {{ formatCurrency(account.amountOverdue) || "N/A" }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca"
                          >PAYMENT FREQUENCY</strong
                        >
                        :
                        {{ PMTFREQ(account.paymentFrequency) }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">REPAYMENT TENURE</strong>
                        :
                        {{
                          account.paymentTenure
                            ? account.paymentTenure + " Months"
                            : "N/A"
                        }}
                      </div>
                      <div>
                        <strong style="color: #00a6ca">INTEREST RATE</strong> :
                        N/A
                      </div>
                      <div>
                        <strong style="color: #00a6ca">EMI</strong> :
                        {{ formatCurrency(account.emiAmount) }}
                      </div>
                    </td>

                    <!-- STATUS -->
                    <td
                      style="
                        vertical-align: top;
                        padding: 0.375rem 0.5rem;
                        border: 1px solid #dee2e6;
                        line-height: 1.6;
                      "
                    >
                      <div>
                        <strong>{{ account.status || "NA" }}</strong>
                      </div>
                    </td>
                  </tr>
                </table>

                <!-- DPD / Asset Classification -->
                <div style="margin-top: 0.625rem">
                  <table
                    style="
                      width: 100%;
                      margin-bottom: 0.625rem;
                      font-size: 0.75rem;
                      border-collapse: collapse;
                    "
                  >
                    <tr>
                      <td
                        style="
                          font-weight: bold;
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        DAYS PAST DUE/ASSET CLASSIFICATION
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        <strong style="color: #00a6ca">START DATE :</strong>
                        {{ formatDate(account.paymentStartDate) }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        <strong style="color: #00a6ca">END DATE :</strong>
                        {{ formatDate(account.paymentEndDate) }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        <strong style="color: #00a6ca">LAST PAYMENT :</strong>
                        {{ formatDate(account.lastPaymentDate) }}
                      </td>
                    </tr>
                  </table>
                  <table
                    style="
                      width: 100%;
                      margin-bottom: 0.625rem;
                      font-size: 0.75rem;
                      border-collapse: collapse;
                    "
                  >
                    <thead>
                      <tr>
                        <th
                          style="
                            background-color: #f5f5f5;
                            font-weight: bold;
                            text-align: center;
                            padding: 0.5rem 0.25rem;
                            border: 1px solid #dee2e6;
                          "
                        >
                          YEAR
                        </th>
                        <th
                          *ngFor="let month of months"
                          style="
                            background-color: #f5f5f5;
                            font-weight: bold;
                            text-align: center;
                            padding: 0.5rem 0.25rem;
                            border: 1px solid #dee2e6;
                          "
                        >
                          {{ month }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let year of getDPDYears(account)">
                        <td
                          style="
                            color: #17a2b8;
                            font-weight: bold;
                            vertical-align: middle;
                            padding: 0.375rem 0.25rem;
                            border: 1px solid #dee2e6;
                            text-align: center;
                          "
                        >
                          {{ year }}
                        </td>
                        <td
                          *ngFor="let month of months"
                          style="
                            vertical-align: middle;
                            padding: 0.375rem 0.25rem;
                            border: 1px solid #dee2e6;
                            text-align: center;
                          "
                        >
                          {{ getDPDValue(account, year, month) || "-" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Enquiry Details -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              CONSUMER ENQUIRY DETAILS
            </h3>
            <div
              *ngIf="cibilData?.consumerCreditData[0]?.enquiries?.length"
              style="
                margin-bottom: 1.875rem;
                border-radius: 0.375rem;
                page-break-inside: avoid;
                padding: 0.3125rem 0.3125rem;
                border: 1px solid #e0e0e0;
              "
            >
              <div style="padding: 0.3125rem 0px">
                <h4
                  style="
                    color: #00a6ca;
                    font-size: 1rem;
                    font-weight: 600;
                    margin-bottom: 0.9375rem;
                  "
                >
                  ENQUIRIES
                </h4>
                <table
                  style="
                    width: 100%;
                    margin-bottom: 0.625rem;
                    font-size: 0.75rem;
                    border-collapse: collapse;
                  "
                >
                  <thead>
                    <tr>
                      <th
                        style="
                          background-color: #f5f5f5;
                          font-weight: bold;
                          text-align: center;
                          padding: 0.5rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        MEMBER NAME
                      </th>
                      <th
                        style="
                          background-color: #f5f5f5;
                          font-weight: bold;
                          text-align: center;
                          padding: 0.5rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        ENQUIRY DATE
                      </th>
                      <th
                        style="
                          background-color: #f5f5f5;
                          font-weight: bold;
                          text-align: center;
                          padding: 0.5rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        ENQUIRY PURPOSE
                      </th>
                      <th
                        style="
                          background-color: #f5f5f5;
                          font-weight: bold;
                          text-align: center;
                          padding: 0.5rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        ENQUIRY AMOUNT
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let enquiry of cibilData?.consumerCreditData[0]
                          ?.enquiries
                      "
                    >
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        {{ enquiry.memberShortName }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                          text-align: center;
                        "
                      >
                        {{ formatDate(enquiry.enquiryDate) }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                        "
                      >
                        {{ getEnquiryPurposeText(enquiry.enquiryPurpose) }}
                      </td>
                      <td
                        style="
                          vertical-align: middle;
                          padding: 0.375rem 0.25rem;
                          border: 1px solid #dee2e6;
                          text-align: center;
                        "
                      >
                        {{ formatCurrency(enquiry.enquiryAmount) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Dispute Remarks -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              CONSUMER DISPUTE REMARKS
            </h3>
            <div
              style="
                margin-bottom: 1.875rem;
                border-radius: 0.375rem;
                page-break-inside: avoid;
                padding: 0.3125rem 0.3125rem;
                border: 1px solid #e0e0e0;
              "
            >
              <div style="padding: 0.3125rem 0px">
                <h4
                  style="
                    color: #00a6ca;
                    font-size: 1rem;
                    font-weight: 600;
                    margin-bottom: 0.9375rem;
                  "
                >
                  DISPUTES
                </h4>
                <div
                  style="
                    font-size: 0.875rem;
                    color: #34495e;
                    text-align: center;
                    padding: 1.875rem;
                    background: #f8f9fa;
                    border-radius: 0.25rem;
                  "
                >
                  <i
                    class="fa-regular fa-folder-open"
                    style="font-size: 1.5rem; margin-bottom: 0.625rem; display: block"
                  ></i>
                  No Consumer Dispute Remarks available.
                </div>
              </div>
            </div>

            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
              "
            >
              GLOSSARY
            </h3>
            <div style="padding: 0.3125rem 0px">
              <table
                style="
                  width: 100%;
                  margin-bottom: 0.625rem;
                  font-size: 0.75rem;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      REPORT SECTION
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      KEY TERM / CODE
                    </th>
                    <th
                      style="
                        background-color: #f5f5f5;
                        font-weight: bold;
                        text-align: center;
                        padding: 0.5rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      DESCRIPTION
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Report name
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      -
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Consumer CIR
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Consumer Details
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      e
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Enriched through Enquiry
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Identification(s)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      ID Types
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Income Tax ID Number (PAN)<br />
                      Passport Number<br />
                      Voter ID<br />
                      Driver's License Number<br />
                      Ration Card Number<br />
                      Universal ID Number (UID)
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Telephone(s)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      Telephone Types
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Latest 4 Telephone details reported.<br />
                      Mobile phone<br />
                      Home Phone<br />
                      Office phone<br />
                      Not Classified
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Email Contact(s)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      -
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Latest 4 emails reported.
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Employment Information(s)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      Occupation Codes
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Latest Employment detail reported.<br />
                      Salaried<br />
                      Self Employed Professionals<br />
                      Self Employed<br />
                      Others
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Address(es)
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      Address Category
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Latest 4 address reported.<br />
                      Permanent Address<br />
                      Residence Address<br />
                      Office Address<br />
                      Not categorized
                    </td>
                  </tr>
                  <tr>
                    <td
                      rowspan="3"
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Consumer Account Details
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      Account Information
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Active: Account not closed<br />
                      Inactive: Closed account<br />
                      Date Opened: Date of first disbursement<br />
                      Date Closed: Date of account closure<br />
                      Date Reported & Certified: Most recent date reported by
                      reporting member<br />
                      Last Payment Date: Most recent date a payment was made on
                      the account.
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      Day Past Due/Asset Classification
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Start date: Beginning of the payment history<br />
                      End date: End of the payment history<br />
                      000: Payment is made on the due date<br />
                      001–900: Payment is missed by number of days from the due
                      date<br />
                      STD: Payments being made within 90 days<br />
                      SMA: Special account created for reporting Standard
                      Accounts moving toward Sub-Standard<br />
                      SUB: Payments being made after 90 days<br />
                      DBT: The account has remained Sub-Standard for 12
                      months<br />
                      LSS: The account where loss has been identified and
                      remains uncollectable<br />
                      XXX: Data not reported by Institution
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      Information under dispute
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Consumer has raised grievance request regarding issue in
                      correctness of the data reported by Financial Institution
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Enquiry Details
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                        text-align: center;
                      "
                    >
                      Not Disclosed
                    </td>
                    <td
                      style="
                        vertical-align: middle;
                        padding: 0.375rem 0.25rem;
                        border: 1px solid #dee2e6;
                      "
                    >
                      Enquiry made with other Members
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- End of Report -->
            <div
              style="
                margin-bottom: 1.875rem;
                border-radius: 0.375rem;
                page-break-inside: avoid;
                padding: 0.3125rem 0.3125rem;
                border: 1px solid #e0e0e0;
                text-align: center;
              "
            >
              <h3
                style="
                  font-size: 1.125rem;
                  font-weight: 600;
                  margin: 0.9375rem 0;
                  color: #00a6ca;
                "
              >
                END OF REPORT ON
                {{ cibilData?.consumerCreditData[0]?.names[0]?.name }}
              </h3>
            </div>

            <!-- Disclaimer -->
            <h3
              style="
                font-size: 1.125rem;
                font-weight: 600;
                padding-bottom: 0px;
                margin: 1.125rem 0.3125rem 0px !important;
                color: #00a6ca;
              "
            >
              DISCLAIMER
            </h3>
            <div
              style="
                margin-bottom: 1.875rem;
                border-radius: 0.375rem;
                page-break-inside: avoid;
                padding: 0.3125rem 0.3125rem;
                border: 1px solid #e0e0e0;
              "
            >
              <div style="padding: 0.3125rem 0px; font-size: 0.6875rem; line-height: 1.4">
                <p style="margin-bottom: 0.625rem">
                  All information contained in this credit report has been
                  collated by TransUnion CIBIL Limited (TU CIBIL) based on
                  information provided/ submitted by its various members
                  ("Members"), as part of periods data submission and Members
                  are required to ensure accuracy, completeness and veracity of
                  the information submitted. The credit report is generated
                  using the proprietary search and match file of TU CIBIL. TU
                  CIBIL uses its best efforts to ensure accuracy, completeness
                  and veracity of the information contained in the Report, and
                  shall only be liable and / or responsible if any discrepancies
                  are directly attributable to TU CIBIL. The use of this report
                  is governed by the terms and conditions of the Operating Rules
                  for TU CIBIL and its Members.
                </p>
              </div>
            </div>
            <hr style="color: #00a6ca; height: 2px" />
            <p style="margin-bottom: 0.625rem">
              © 2023 TransUnion CIBIL Limited (Formerly Credit Information
              Bureau (India)) Limited. All rights reserved.
            </p>
            <p style="margin-bottom: 0; color: #000; font-weight: bold">
              TransUnion CIBIL CIN : U723004H2000PLC128359
            </p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
